module.exports = __webpack_public_path__ + "static/flags/NH-e10027cc616973edc14aca5a8d2454a9.gif";